import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export interface ProgramEnrollmentImportRow {
    rowIndex: number;
    clientId: string;
    programId?: string;
    startDate: string;
    endDate?: string;
}

export interface ProgramEnrollmentImportValidationError {
    rowIndex: number;
    field: string;
    message: string;
}

export const previewProgramEnrollmentImport = async (rows: ProgramEnrollmentImportRow[]): Promise<ProgramEnrollmentImportValidationError[]> => {
    const result = await axios.post(`${baseUrl}/program-enrollment-import/preview`, { rows });
    return result.data.errors || [];
};

export const importProgramEnrollmentRow = async (row: ProgramEnrollmentImportRow): Promise<void> => {
    await axios.post(`${baseUrl}/program-enrollment-import/rows`, row);
};
